module.exports = __webpack_public_path__ + "img/pi-2-3.6fc44ef7.jpg";